var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 32,
    fill: "#FF4B4B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 33.5,
    stroke: "#FF4B4B",
    strokeOpacity: 0.1,
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2582_72528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 21.6719C32.3628 21.6719 29.7849 22.4539 27.5922 23.9189C25.3996 25.384 23.6906 27.4664 22.6814 29.9028C21.6723 32.3391 21.4082 35.02 21.9227 37.6064C22.4372 40.1928 23.7071 42.5686 25.5718 44.4333C27.4365 46.298 29.8122 47.5679 32.3986 48.0823C34.9851 48.5968 37.6659 48.3328 40.1023 47.3236C42.5386 46.3144 44.621 44.6055 46.0861 42.4128C47.5512 40.2202 48.3332 37.6423 48.3332 35.0052C48.3332 33.2542 47.9883 31.5204 47.3182 29.9028C46.6482 28.2851 45.666 26.8152 44.4279 25.5771C43.1898 24.339 41.72 23.3569 40.1023 22.6868C38.4846 22.0168 36.7508 21.6719 34.9998 21.6719ZM40.3332 38.6719C40.3332 39.1139 40.1576 39.5378 39.845 39.8504C39.5325 40.1629 39.1085 40.3385 38.6665 40.3385H31.3332C30.8911 40.3385 30.4672 40.1629 30.1547 39.8504C29.8421 39.5378 29.6665 39.1139 29.6665 38.6719V31.3385C29.6665 30.8965 29.8421 30.4726 30.1547 30.16C30.4672 29.8475 30.8911 29.6719 31.3332 29.6719H38.6665C39.1085 29.6719 39.5325 29.8475 39.845 30.16C40.1576 30.4726 40.3332 30.8965 40.3332 31.3385V38.6719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1266 29.6641H30.8736C30.2071 29.6641 29.6667 30.2044 29.6667 30.8709V39.1239C29.6667 39.7904 30.2071 40.3307 30.8736 40.3307H39.1266C39.7931 40.3307 40.3334 39.7904 40.3334 39.1239V30.8709C40.3334 30.2044 39.7931 29.6641 39.1266 29.6641Z",
    fill: "#FF4B4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2582_72528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.8bb08c14a09d51c65c691776567fc91e.svg";
export { ForwardRef as ReactComponent };